import React, { useContext, useEffect, useState } from 'react';
import {
  Link,
  useLocation,
  useNavigate,
  useRoutes,
  useSearchParams,
} from 'react-router-dom';
import './SideBar.css';
import { SidebarContext } from './SidebarContext';
import { useUnsavedChanges } from '../../Portals/Context/UnSavedChangesContext';
import { getService } from '../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../api';

interface MenuState {
  [key: string]: boolean;
}

interface SubMenuState {
  [parent: string]: {
    [key: string]: boolean;
  };
}

const SideBar: React.FC = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const [servicess, setServices] = useState<any>(null);
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const { toggleMenu, openMenu } = useContext(SidebarContext);
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const pathname = useNavigate();
  const [expandedMenus, setExpandedMenus] = useState<{
    [key: string]: boolean;
  }>({});
  const menuItems = [
    {
      name: 'Hospital Profiling',
      key: 'isHospitalProfiling',
      path: '/vendorDashboard/activateDashbord/HospitalViewProfile',
      to: '/portals/dashboard',
      img: '/images/hospitalCenters.svg',
      activeImg: '/images/hospitalCentersActive.svg',
      condition: (data: any) => data.isHospitalProfiling,
    },
    {
      name: 'Company Profiling',
      key: 'isCompanyProfiling',
      path: '/vendorDashboard/activateDashbord/companyViewProfile',
      to: '/portals/dashboard',
      img: '/images/hospitalCenters.svg',
      activeImg: '/images/hospitalCentersActive.svg',
      condition: (data: any) => data.isCompanyProfiling,
    },
    // {
    //   name: "Event Profiling",
    //   key: "isEventProfiling",
    //   path: "/vendorDashboard/activateDashbord/eventViewProfile",
    //   to: "/portals/dashboard",
    //   img: "/images/hospitalCenters.svg",
    //   activeImg:"/images/hospitalCentersActive.svg",
    //   condition: (data: any) => data.isEventProfiling,
    // },
    {
      name: 'Events',
      key: 'isEmailMarketing',
      path: '/vendorDashboard/activateDashbord/eventListing',
      img: '/images/eventlist.svg',
      activeImg: '/images/eventlistActive.svg',
      condition: (data: any) => data.isEventListing,
    },
    {
      name: 'Content Marketing',
      key: 'isContentMarketing',
      path: '/vendorDashboard/activateDashbord/contentMarketing',
      img: '/images/contentMarket.svg',
      activeImg: '/images/contentMarketingProfile.svg',
      condition: (data: any) => data.isContentMarketing,
    },

    {
      name: 'Banner Ads ',
      key: 'isBannerAdsGroup', // NEW GROUPED KEY
      img: '/images/bannerad.svg',
      activeImg: '/images/banneradsActive.svg',
      subMenu: [
        {
          name: 'Website',
          key: 'isBannerAds',
          path: '/vendorDashboard/activateDashbord/bannerAds',
          condition: (data: any) => data?.isBannerAds,
        },
        {
          name: 'Newsletter Ads',
          key: 'isNewsLetterAds',
          path: '/vendorDashboard/activateDashbord/newsletter',
          condition: (data: any) => data?.isNewsLetterAds,
        },
      ],
      condition: (data: any) => data?.isBannerAds || data?.isNewsLetterAds, // ✅ Condition to show parent
    },
    {
      name: 'Email Marketing',
      key: 'isEmailMarketing',
      path: '/vendorDashboard/activateDashbord/emailMarketing',
      img: '/images/emailMarketingInActive.svg',
      activeImg: '/images/emailMarketings.svg',
      condition: (data: any) => data.isEmailMarketing,
    },
    {
      name: 'Print Advertisement',
      key: 'isPrintAd',
      path: '/vendorDashboard/activateDashbord/printAd',
      img: '/images/Print advertising.svg',
      activeImg: '/images/Print advertisingActive.svg',
      condition: (data: any) => data?.isPrintAd,
    },
  ];
  const toggleMenu1 = (menuKey: string) => {
    setExpandedMenus((prev: any) => ({
      [menuKey]: !prev[menuKey], // Toggle only the clicked menu
    }));
  };
  useEffect(() => {
    fetchDetails();
  }, []);

  const fetchDetails = async () => {
    try {
      let id = localStorage.getItem('vendorId');
      const response = await getService(
        API_ENDPOINTS.getActivatedServices + '?vendorId=' + id
      );
      setServices(response.data);
    } catch (error) {
      console.error('Error fetching services:', error);
    }
  };
  const back = () => {
    let screen = localStorage.getItem('screen');
    if (screen === 'active') {
      navigate('/portals/vendors/activeVendor');
    } else {
      navigate('/portals/vendors/inActiveVendor');
    }
  };
  return (
    <div
      className={`mainSidebar h-screen bg-white text-center z-10 fixed transition-transform duration-300 ${
        toggleMenu ? 'translate-x-0' : '-translate-x-full'
      } w-inherit sm:translate-x-0 sm:w-64 lg:w-[20.6rem] md:w-[21.6rem] max-[1920px]:w-[20.6rem] w-[16rem] scroolCls overflow-y-scroll`}
    >
      <section className='sidebar'>
        <div className='flex align-center p-2 justify-center'>
          <span
            className='flex justify-center items-center mt-6'
            // onClick={gotoDashBoard}
          >
            <div>
              <span
                className='gradient-text flex items-center'
                style={{ color: '#ffffffde', marginLeft: '' }}
              >
                <button onClick={() => navigate(-1)}>
                  <img src='/images/back.svg' className='mr-2' />
                </button>
                {<>FertilityIn </>}
              </span>
            </div>
          </span>
          <span
            className='mt-[10px] text-white text-xl cursor-pointer sm:hidden'
            onClick={openMenu}
          >
            X
          </span>
        </div>
        <ul className='sidebar-menu tree m-5 text-left' data-widget='tree'>
          {servicess &&
            menuItems
              .filter((item: any) => item.condition(servicess))
              .map((item: any) => {
                const isSubmenuActive = item.subMenu?.some((sub: any) =>
                  currentPath.startsWith(sub.path)
                );
                const isActive =
                  currentPath.startsWith(item.path) || isSubmenuActive;
                const isExpanded = expandedMenus[item.key] || false; // Ensure a boolean value

                return (
                  <div key={item.key} className='flex flex-col'>
                    {/* Main Menu Button */}
                    <button
                      onClick={() =>
                        item?.subMenu
                          ? toggleMenu1(item.key)
                          : navigate(item.path)
                      }
                      className={`flex items-center justify-between w-full p-3 rounded-md font-medium transition ${
                        isActive
                          ? 'text-primary-color bg-[#fff7f7]'
                          : 'text-gray-600 hover:bg-[#fff7f7]'
                      }`}
                    >
                      <div className='flex items-center'>
                        <img
                          src={isActive ? item.activeImg || item.img : item.img}
                          alt={item.name}
                          className='w-6 h-6 mr-3'
                        />
                        <span>{item.name}</span>
                      </div>
                      {item.subMenu && (
                        <span
                          className={`transform transition-transform ${
                            isExpanded ? '' : 'rotate-180'
                          }`}
                        >
                          <img src='/images/expandMenu.svg' />
                        </span>
                      )}
                    </button>

                    {/* Submenu Items */}
                    {item.subMenu && isExpanded && (
                      <div className='ml-6 mt-1'>
                        {item.subMenu
                          .filter((sub: any) => sub.condition(servicess))
                          .map((sub: any) => {
                            const isSubActive = currentPath.startsWith(
                              sub.path
                            );
                            return (
                              <button
                                key={sub.path}
                                onClick={() => navigate(sub.path)}
                                className={`flex items-center w-full p-2 rounded-md text-sm font-medium transition ${
                                  isSubActive
                                    ? ' text-primary-color'
                                    : 'hover:bg-[#fff7f7] text-gray-600'
                                }`}
                              >
                                {sub.name}
                              </button>
                            );
                          })}
                      </div>
                    )}
                  </div>
                );
              })}
        </ul>
      </section>
    </div>
  );
};

export default SideBar;
